<template>
    <div class="step-section">
        <div class="container">
            <header class="step-section__header" v-if="page.title">
                <h1 class="heading no-arrow heading-static">
                    <b>{{ page.title }}</b>
                </h1>
            </header>
            <div class="step-section__content">
                <div class="row">
                    <div class="col-12">
                        <div class="conent-page text-page" v-html="pageContent"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {getStaticPage} from '@/api';
    import store from '@/store/index';
    import {getCompanyInfo} from "../api";

    export default {
        name: 'Static',
        props: {
            slug: {
                type: String,
                required: true,
            },
        },
        metaInfo() {
            const {page, $t} = this;
            var companyName = '';
            if (store.state.companyInfo !== undefined) {
                if (store.state.companyInfo.seo_title !== '') {
                    companyName = store.state.companyInfo.seo_title + " | ";
                } else {
                    companyName = store.state.companyInfo.name + " | ";
                }

            }
            return {
                title: page.title + ' | ' + companyName + $t('titleWindowConfigurator'),
            }
        },
        beforeRouteEnter: async (to, from, next) => {
            if (await store.dispatch('hasStaticPage', to.params.slug)) {
                next();
            } else {
                next({name: 'error.notFound'});
            }
        },
        data() {
            return {
                page: {
                    content: null,
                },
            };
        },
        methods: {
            ...mapActions({
                getStaticPageIdBySlug: 'getStaticPageIdBySlug',
            }),
            async loadStaticPage() {
                const {slug, getStaticPageIdBySlug} = this;
                const id = await getStaticPageIdBySlug(slug);

                if (!id) {
                    throw new Error(`Could not find page with slug "${slug}".`);
                }

                this.page = await getStaticPage(id);
            },
        },
        computed: {
            pageContent() {
                const {page} = this;
                return page.content ? JSON.parse(page.content) : null;
            },
            /* ...mapState({
                 companyInfo: state => state.companyInfo,
             }),*/
        },
        watch: {
            slug: {
                immediate: true,
                async handler() {
                    await this.loadStaticPage();
                },
            },
        },
    };
</script>
